export default __webpack_public_path__ + "static/media/coast.54b1b992.jpg";